import React, { useEffect } from 'react'
import { useState } from 'react';
import Swal from 'sweetalert2';
import api from '../Utils/api';
import axios from 'axios';
import { s3Url } from '../Utils/constants';
import { useCommonUserProvider } from '../Providers/Common/User';
import Avatar from "@mui/material/Avatar";
import { Button, Upload } from "antd";

const UserProfileAvatar = ({user, updateCount, setUpdateCount, updateHandler}) => {
    const [file, setFile] = useState();
    const { updateUserProfile } = useCommonUserProvider();
    useEffect(()=>{

    },[user.profilePhoto, updateCount])
    const uploadFile = async ({ file: cur, onProgress }) => {
        // Invalid request
        if (!user?.id || !cur) return;
    
        // Validation
        if (cur.type.indexOf("image") === -1 || cur.size > 1000000) {
          const sizeIssue = cur.size > 1000000;
          Swal.fire({
            icon: "error",
            title: sizeIssue ? "Error" : "Invalid file type",
            text: sizeIssue
              ? "File size should be less than 1 MB"
              : "Please upload an image file",
          });
          setFile([]);
          return;
        }
    
        try {
          setFile([{ uid: user.id, name: cur.name, status: "uploading" }]);
          const Key = user.id + Date.now()
    
          const upload = await api.get(`/user/getpresigneduploadurl?filename=${Key}&filetype=${cur.type}`)
    
          if (upload?.data?.success && upload?.data?.result) {
            const s3_res = await axios.put(upload?.data?.result, cur)
    
            if (s3_res.status === 200) {
                if(updateHandler){
                    updateHandler(s3Url + Key);
                }else{
                    await updateUserProfile({
                      ...user,
                      profilePhoto: s3Url + Key,
                    });
                }
              setFile([]);
              setUpdateCount(updateCount + 1);
            }
          }
        } catch (err) {
          console.log(err);
          setFile([]);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong",
          });
        }
      };
  return (
    <div className="mt-8 flex md:flex-row flex-col md:space-y-0 space-y-8">
        <div className="flex flex-row space-x-4">
          {/* HACK: Used update count to refresh image */}
          {user.profilePhoto ? (
            <img
              alt="user"
              className="h-36 w-36 rounded-full"
              src={`${user.profilePhoto}?${updateCount}`}
            />
          ) : (
            <Avatar sx={{ height: 144, width: 144 }} />
          )}
          <div className="flex flex-col space-y-2 justify-center">
            <Upload
              accept="image/*"
              maxCount={1}
              fileList={file}
              onRemove={() => setFile([])}
              customRequest={uploadFile}
            >
              <Button
                style={{
                  height: "35px",
                  background: "#139588",
                  borderRadius: "5px",
                  color: "white",
                }}
              >
                Change Picture
              </Button>
            </Upload>
          </div>
        </div>
      </div>
  )
}

export default UserProfileAvatar